import { ref } from 'vue'
import { useAlert } from '~/plugins/alert'

export default function useApiErrorHandling(
  errorFields: string[] | undefined = undefined,
) {
  const errors = ref(
    !errorFields
      ? {}
      : errorFields.reduce((errors: Record<string, string>, key) => {
          return {
            ...errors,
            [key]: '',
          }
        }, {}),
  )
  const alert = useAlert()
  function handleErrors(error: any) {
    console.warn(error)
    if (error.response) {
      let response = error.response
      let status = response.status
      const data = <any>response?.data
      const message: string = <string>data?.message || ''
      if (status == 403 && message) return alert(message)
      const responseErrors = data?.errors
      if (responseErrors && Object.keys(errors.value)?.length) {
        let messageErrors = ''
        Object.keys(responseErrors).forEach((key) => {
          if (!errors?.value) return
          if (!(key in errors.value)) {
            messageErrors += `\n${responseErrors[key][0]}`
          }
          errors.value[key] = responseErrors[key][0]
        })
        if (messageErrors) alert(messageErrors)
        return
      }
      if (responseErrors) {
        const message = Object.keys(responseErrors)
          .map((key) => {
            return responseErrors[key][0]
          })
          .join('\n')
        if (message) {
          alert(message)
          return
        }
      }
      if (message) {
        alert(message)
      }
    }
  }
  return {
    handleErrors,
    errors,
  }
}
